<template lang="">
  <div>

    <!-- search -->
    <div class="search">
      <el-form :model="searchForm" size="small" label-width="70px">
        <el-col :span="5" class="formWidth">
          <el-form-item label="活动名称">
            <el-input v-model="searchForm.comname" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" class="formWidth">
          <el-form-item label="年份">
            <el-input v-model="searchForm.year" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="10" class="formWidth">
          <el-form-item label="活动状态" >          
            <el-radio-group v-model="searchForm.comstatus">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button label="1">未开始</el-radio-button>
              <el-radio-button label="2">报名中</el-radio-button>
              <el-radio-button label="4">评分中</el-radio-button>
              <el-radio-button label="3">已结束</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>

        
        <el-col :span="4" class="formWidth" style="text-align: right;;" label-width="0">
          <el-form-item label="" label-width="0px" style="white-space: nowrap;">
            <el-button type="success" size="small" @click="search()"><i class="fa fa-search"></i> 查 询</el-button>
            <el-button type="primary" size="small" @click="activityAdd()"><i class="fa fa-plus"></i> 创建活动</el-button>
          </el-form-item>          
        </el-col>
        <div class="clear"></div>
      
      </el-form>
    </div>

    <!-- list -->
    <div class="list" v-loading="loading">
      <table class="table table-highlight table-border table-hover table-striped align-center font_12">
        <thead>
          <tr>
            <th style="width:30%">活动全称</th>
            <th style="width:15%">活动简称</th>
            <th>所属年份</th>
            <th>时间范围</th>
            <th>状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in activityList">
            <td class="align-left " :title="item.comname" ><div class="oneRow fullname">{{item.comname}}</div></td>
            <td class="" :title="item.abbrname"><div class="oneRow">{{item.abbrname}}</div></td>
            <td>{{item.year}}</td>
            <td>{{item.start}} 至 {{item.end}}</td>
            <td>{{item.comstatus_name}}</td>
            <td>
              <!-- <el-button size="mini" type="success" plain>编辑</el-button>
              <el-button size="mini" type="primary" plain>删除</el-button> -->
              <a href="javascript:void(0)" @click="getPrize(item.competitionid)">奖项</a> | 
              <a href="javascript:void(0)" @click="activityEdit(item)">编辑</a> | 
              <a href="javascript:void(0)" @click="setJudges(item)">评委</a> | 
              <a href="javascript:void(0)" @click="activityDelete(item.competitionid,item.comname)">删除</a>
            </td>
          </tr>
        </tbody>
      </table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="total" :current-page="searchForm.page" @current-change="current_change" :page-size="searchForm.length"></el-pagination>
    </div>

    <!-- add/edit -->
    <el-dialog :title="(newActivity)?'活动创建':'编辑活动'" class="activityInfoDialog" :visible.sync="activityInfoDialog" :width="dialogWidth" :close-on-click-modal="false" @close="clearForm()" top="5vh">
      <div class="main" style="max-height:70vh;overflow-y: auto;">
          <el-form :model="activityInfo" ref="activityInfo" size="small" label-width="100px">
            <el-form-item label="活动全称" prop="comname" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
              <el-input v-model="activityInfo.comname" maxlength="100" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="活动简称" prop="abbrname" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
              <el-input v-model="activityInfo.abbrname" maxlength="10" show-word-limit></el-input>
            </el-form-item>

            <el-form-item label="奖项分类" class="star">
              <el-form-item v-for="(item,index) in activityInfo.prizeType" :key="index">
                <el-input v-model="item.typename" class="inputGroup" @input="change($event)" @change="change($event)">
                  <span v-if="index==0" slot="append" @click="addPrizeType()" title="添加分类"><i class="fa fa-plus"></i></span>
                  <span v-else slot="append" @click="removePrizeType(item)" title="移除分类"><i class="fa fa-minus"></i></span>
                  <span type="waring" slot="append" @click="addPrizeType1(index)" class="btn" title="添加子类"><i class="fa fa-chevron-down"></i></span>
                </el-input>
                
                <el-form-item v-for="(item1,index1) in item.children" :key="index1" >
                  <!-- <input type="text" v-model="item1.typename" /> -->
                  <el-input v-model="item1.typename" class="inputGroup child" @input="change($event)" @change="change($event)" >
                    <span slot="append" @click="removePrizeType1(index,item1)" title="移除子类"><i class="fa fa-minus"></i></span>
                  </el-input>
                </el-form-item>

              </el-form-item>          
            </el-form-item>

            <el-form-item label="所属年份" prop="year" :rules="{ required: true, message: '请填写', trigger: 'blur' }" style="margin-top:-10px;">
              <el-input v-model="activityInfo.year" ></el-input>
            </el-form-item>
            <el-form-item label="参赛指南">
              <el-input v-model="activityInfo.entry_guide" placeholder="专题、文章等活动链接"></el-input>
            </el-form-item>
            <el-form-item label="参赛资料">          
              <el-upload            
                action=""
                :http-request="changeFileUpload"
                :limit="1"
                :file-list="fileList"
                :on-remove="cleanFile"
                :on-preview="preview">
                <el-button size="small" type="primary">点击上传</el-button><span slot="tip" style="margin-left:5px;" class="el-upload__tip">企业在提交作品时可下载此参赛资料</span>
              </el-upload>
            </el-form-item>
            <el-form-item label="作品形式" prop="entry_data_type" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
              <el-radio-group v-model="activityInfo.entry_data_type">
                <el-radio-button label="0">图文和视频选一上传</el-radio-button>
                <el-radio-button label="1">图文和视频都可上传</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="时间范围" prop="range" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
              <el-date-picker v-model="activityInfo.range" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="活动状态" prop="comstatus" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
              <el-radio-group v-model="activityInfo.comstatus">
                <el-radio-button label="1">未开始</el-radio-button>
                <el-radio-button label="2">报名中</el-radio-button>
                <el-radio-button label="4">评分中</el-radio-button>
                <el-radio-button label="3">已结束</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="clearForm()"><i class="fa fa-times"></i> 取 消</el-button>
        <el-button size="small" type="primary" @click="saveActivity('activityInfo')"><i class="fa fa-check"></i> 保 存</el-button>
      </div>
    </el-dialog>

    <!-- 奖项 -->
    <el-dialog :title="'奖项'" :visible.sync="prizeDialog" width="800px" :close-on-click-modal="false" >
      <div class="prizelist">
        <div v-for="item in prizeList" :key="item.typeid" :class="(item.children.length==0)?'type':''"><span>{{item.typename}}</span>
          <p v-if="item.children.length==0">
            <el-tag :type="(prize.awardstatus==1)?'success':'danger'" :title="(prize.awardstatus==1)?'已启用':'未启用'" v-for="prize in item.list" :key="prize.awardid" size="mini">{{prize.awardname}}</el-tag>
          </p>
          <div v-else v-for="sub_item in item.children" class="type"><span>{{sub_item.typename}}</span>
            <p>
              <el-tag :type="(prize1.awardstatus==1)?'success':'danger'" :title="(prize1.awardstatus==1)?'已启用':'未启用'" v-for="prize1 in sub_item.list" :key="prize1.awardid" size="mini">{{prize1.awardname}}</el-tag>
              <!-- <el-tag :type="(prize1.awardstatus==1)?'success':'danger'" :title="(prize1.awardstatus==1)?'已启用':'未启用'" v-for="prize1 in 20" :key="prize1.awardid" size="mini">最佳新人奖</el-tag> -->
            </p>
          </div>
        </div>
        
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="prizeDialog=false"><i class="fa fa-times"></i> 取 消</el-button>
      </div>
    </el-dialog>

    <!-- 设置评委 -->
    <el-dialog title="设置评委" :visible.sync="setJudgesDialog" width="800px" :close-on-click-modal="false"  top="5vh" @close="closeJudges">
      <div class="judgeslist">
        <!-- <div v-for="item in judgesList" class="logo">
          <el-image :src="imgBase+item.filephotoid" fit="cover"></el-image>
          <span class="" title="姓名">{{item.name}}</span>
        </div> -->
        <el-transfer filterable :filter-method="filterMethod" :titles="['备选评委', '已选评委']" filter-placeholder="请输入评委姓名" v-model="members" :data="judgesList" :props="{key: 'id', label: 'name',disabled:'disabled'}"></el-transfer>
        
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="setJudgesDialog=false"><i class="fa fa-times"></i> 取 消</el-button>
        <el-button size="small" type="primary" @click="saveJudges()"><i class="fa fa-save"></i> 保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import * as API from '@/api/main'
export default {
  data() {
    return {
      imgBase:this.$store.state.imgBaseUrl,//图片前缀
      loading:false,
      total:0,
      searchForm:{
        page:1,
        length:10,
        comstatus:"",
      },
      activityList:[],
      activityInfo:{
        comname:"",//活动名称
        abbrname:"",//活动简称
        year:"",//所属年份
        range:[],//所属年份
        comstatus:"",//状态
        start:"",//开始时间
        end:"",//结束时间
        prizeType:[
          {
            typename:"",
            typeid:"",
            children:[
              {
                typename:"",
                typeid:"",
              },
            ]
          },
        ],//奖项分类
      },
      activityInfoDialog:false,//添加、编辑活动面板开关
      newActivity:false,
      statusList:[],//状态list
      prizeList:[],//奖项列表
      prizeDialog:false,
      dialogWidth:"500px",
      fileList:[],
      setJudgesDialog:false,//设置评委面板
      judgesList:[],//评委列表
      members:[],//已选评委
    };
  },
  filters:{
    filterStatus(value){
      let str = "";
      switch (value) {
        case 1:
          str = "未开始";
          break;
        case 2:
          str = "进行中";
          break;
        case 3:
          str = "已结束";
          break;
      }
      return str;
    }
  },
  watch:{

    "searchForm.comstatus":{
      handler: function() {
        this.search()
      },      
    }

  },
  methods: {
    
    //提交
    saveActivity(formName){
      console.log(this.activityInfo.prizeType)
      this.$refs[formName].validate((valid) => {
          if (valid) {
            this.activityInfo.start=this.activityInfo.range[0];
            this.activityInfo.end=this.activityInfo.range[1];
            if(this.newActivity){
              API.ActivityAdd(this.activityInfo).then(res=>{
                this.$message({
                  message: res.info,
                  type: 'success'
                });
                this.activityInfoDialog=false;              
                this.resetForm("activityInfo");
                this.search();
              })
            }else{
              API.ActivityEdit(this.activityInfo).then(res=>{
                this.$message({
                  message: res.info,
                  type: 'success'
                });
                this.activityInfoDialog=false;              
                this.resetForm("activityInfo");
                this.getlist();
              })
            }            
          } else {
            return false;
          }
        });
    },

    //删除
    activityDelete(id,name){
      this.$confirm('确定删除“'+name+'”活动?', '提示', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          API.ActivityDelete({competitionid:id}).then(res=>{        
            this.$message({
              message: '活动已删除',
              type: 'success',
            })
            this.getlist();
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },

    //重置校验
    resetForm(formName) {
        this.$refs[formName].resetFields();
    },

    //清空表单
    clearForm(){
      setTimeout(() => {        
        this.resetForm("activityInfo");
      }, 0);
      this.activityInfoDialog=false;
    },

    //添加活动
    activityAdd(){
      this.newActivity=true;
      this.activityInfoDialog=true;
      this.activityInfo={
        comname:"",//活动名称
        abbrname:"",//活动简称
        year:"",//所属年份
        range:[],//所属年份
        comstatus:"",//状态
        start:"",//开始时间
        end:"",//结束时间
        prizeType:[
          {
            typename:"",
            typeid:"",
            // children:[
            //   {
            //     typename:"",
            //     typeid:"",
            //   },
            // ]
          },
        ],//奖项分类
        competitionid:"",
        entry_guide:"",//参赛指南
        entry_materials:"",//参赛资料
        entry_data_type:"",//作品形式
      }
      this.fileList=[];
    },

    //编辑活动
    activityEdit(activityInfo){
      this.newActivity=false;
      this.activityInfoDialog=true;
      this.activityInfo={
        comname:activityInfo.comname,//活动名称
        abbrname:activityInfo.abbrname,//活动简称
        year:activityInfo.year,//所属年份
        range:[activityInfo.start,activityInfo.end],//所属年份
        comstatus:activityInfo.comstatus,//状态
        start:activityInfo.start,//开始时间
        end:activityInfo.end,//结束时间
        competitionid:activityInfo.competitionid,//id
        // prizeType:activityInfo.prizeType,//奖项分类
        entry_guide:activityInfo.entry_guide,//参赛指南
        entry_materials:activityInfo.entry_materials,//参赛资料
        entry_data_type:activityInfo.entry_data_type,//作品形式
      }
      var filename=activityInfo.entry_materials.split("/")[1];
      var fileurl=this.imgBase+activityInfo.entry_materials;
      this.fileList=[];
      if(activityInfo.entry_materials){
        this.fileList.push({name: filename, url:fileurl})
      }      
      API.GetAwardType({competitionid:activityInfo.competitionid,is_data:0}).then(res=>{
        this.activityInfo.prizeType=_.cloneDeep(res.list);
        this.$forceUpdate();
      })
    },

    //获取列表
    getlist(){
      this.loading=true;
      API.GetActivityList(this.searchForm).then(res=>{
        this.activityList=res.data.data;
        this.loading=false;
        this.total=res.data.total;
      })
    },

    //分页
    current_change(currentPage){
      // console.log(currentPage)
      this.searchForm.page = currentPage;
      this.getlist();
    },

    //查询
    search(){
      this.current_change(1);
    },

    //获取奖项列表
    getPrize(id){
      API.GetAwardType({competitionid:id,is_data:2}).then(res=>{
        this.prizeList=_.cloneDeep(res.list);
        this.$forceUpdate();
        this.prizeDialog=true;
        console.log(this.prizeList)
      })
    },

    diffrentScreen(){
      if(document.body.clientWidth<1200){
        this.dialogWidth="100vw";
      }
    },

    //添加奖项分类
    addPrizeType(){
      this.activityInfo.prizeType.push({
        typename: '',
        typeid:'',
          // key: Date.now()
      });
      this.$forceUpdate();
      // console.log(this.activityInfo.prizeType)
    },

    //添加子类
    addPrizeType1(index){
      if(this.activityInfo.prizeType[index].children){
        this.activityInfo.prizeType[index].children.push({
          typename: '',
          typeid:'',
            // key: Date.now()
        });
      }else{
        this.activityInfo.prizeType[index].children=[];
        this.activityInfo.prizeType[index].children.push({
          typename: '',
          typeid:'',
            // key: Date.now()
        });
      }
      this.$forceUpdate();
      // console.log(this.activityInfo.prizeType)
    },

    //移除奖项分类
    removePrizeType(item){
      var index = this.activityInfo.prizeType.indexOf(item)
      if (index !== -1) {
        this.activityInfo.prizeType.splice(index, 1)
      }
      this.$forceUpdate();
    },

    //移除子类
    removePrizeType1(index1,item1){
      var index = this.activityInfo.prizeType[index1].children.indexOf(item1)
      if (index !== -1) {
        this.activityInfo.prizeType[index1].children.splice(index, 1)
      }
      this.addPrizeType();
      this.activityInfo.prizeType.pop();
      this.$forceUpdate();
    },

    //刷新奖项分类视图
    change(e){
      this.$forceUpdate();
    },

    //上传附件
    changeFileUpload(options) {
      this.formLoading=true;
      let file = options.file
      // console.log(file)
      var postdata = new FormData();   
      postdata.append('file', file);
      API.UploadFile(postdata).then(res=>{
        this.activityInfo.entry_materials=res.path;
        this.formLoading=false;
      })
    },

    //清除附件
    cleanFile(){
      this.fileList=[];
      this.activityInfo.entry_materials="";
    },

    //下载附件
    preview(file){
      if(file.url){
        window.open(file.url)
      }
      console.log(file.url)      
    },

    //设置评委
    setJudges(item){
      this.members=_.cloneDeep(item.memberids);
      this.activityInfo=_.cloneDeep(item);
      this.setJudgesDialog=true;
    },

    //获取评委
    getJudges(){
      API.GetJudgesList({page:1,length:100,flag:1}).then(res=>{
        this.judgesList=res.data.data;
      })
    },

    //过滤评委
    filterMethod(query, item) {
      return item.name.indexOf(query) > -1;
    },

    //关闭评委面板
    closeJudges(){
      this.members=[];
    },

    //保存评委
    saveJudges(){
      this.activityInfo.members=_.cloneDeep(this.members);
      API.ActivityEdit(this.activityInfo).then(res=>{
        this.$message({
          message: res.info,
          type: 'success'
        });
        this.setJudgesDialog=false;
        this.getlist();
      })
    },

  },
  created() {    
    this.getlist();
    this.diffrentScreen();
    this.getJudges();
  },
  
}
</script>
<style scoped>
  .oneRow{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:200px;}
  .fullname{width:280px;}
  .search{padding-bottom:20px;}
  .inputGroup{margin-bottom:10px;}
  .inputGroup.child{ padding-left: 3em;box-sizing: border-box;background:url(../../assets/images/node.gif) no-repeat 15px top;}
  .inputGroup .btn{margin-left:10px;padding-left:10px;border-left:1px solid #DCDFE6;}
  .inputGroup .btn1{margin-right:10px;padding-right:10px;border-right:1px solid #DCDFE6;}
  .prizelist{line-height:2;}
  .prizelist div{padding-left:2em;}
  .prizelist div.type{display: flex;}
  .prizelist span{margin-right:1em;white-space:nowrap;    margin-left: 0px;}
  .prizelist p{display:inline-block;}
  /* .inputGroup:last-child{margin:0;} */
  .judgeslist{display: flex;flex-wrap: wrap;}
  .judgeslist .logo{width:10%;text-align: center;}
  .judgeslist .logo img{border-radius: 50%;}
  .avatar-uploader-icon{font-size: 28px; color: #8c939d; width: 100px;height: 100px; line-height: 100px;text-align: center;}
  .el-image{width: 50px; height: 50px;border-radius: 50%;display: block;margin:auto;}
  .el-image img{height:100%;}
  .judgeslist .el-transfer{margin:auto;}
  .judgeslist >>> .el-transfer-panel__body{height: 500px;}
  .judgeslist >>> .el-transfer-panel__list.is-filterable{height:calc( 500px - 40px );}
@media screen and (max-width: 1200px){
  .oneRow{width:auto;white-space:unset;}
  .fullname{width:auto;}
  .formWidth{width:100%;}
  .el-dialog{width:100vw;}
}
</style>